import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import TermsAndConditionsDialog from '../TermsAndConditionsDialog';


const useStyles = makeStyles(theme => ({
    downloadImage: {
        marginBottom: theme.spacing(2),
    },
    root: {
        width: 300,
        maxWidth: '100%',
        display: 'inline-block',
        margin: '18px 18px 5px 18px',
    },
    title: {
        fontSize: 19,
    },
    approvalLabel: {
        marginRight: 0,
        marginBottom: 0,
        '& .MuiFormControlLabel-label': {
            fontSize: 13,
        }
    },
    termsGroup: {
        maxWidth: 600,
        '& .MuiFormControlLabel-label': {
            textAlign: 'left',
            fontSize: 14,
        },
    },
    homeButton: {
        '&:hover': {
            color: '#ffffff'
        }
    }
}));

const DownloadButton = (props) => {
    const { url } = props;

    return (
        <Box mt={2} mb={1}>
            <a href={url} target="_blank">
                <Button><img src="/img/download.png" /></Button>
            </a>
        </Box>
    )
}

const ApprovalTerms = (props) => {
    const classes = useStyles();
    const { wedding } = props;

    const [state, setState] = React.useState({
        approve_information_form: false,
        approve_wedding_ceremony_contact: false,
        approve_terms: false,
        hash: wedding.hash,
    });

    const isApproved = wedding.is_approved;

    const handleChange = name => event => {
        const data = {
            ...state,
            [name]: event.target.checked,
        };
        setState(data);
    }

    const currentDate = window.dates;

    const [open, setOpen] = React.useState(false);

    const toggleTerms = e => {
        e.preventDefault();
        setOpen(!open);
    }

    const history = useHistory();

    const submitForm = () => {
        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            let url = '/approval/terms';
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    history.push(`/approval/thank-you?couple_hash=${wedding.hash}`);
                })
                .catch(reason => {
                    alert('An error prevented saving. Please refresh the page and try again.');
                })
        });
    }

    return (
        <Container align="center">
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.title} color="primary" gutterBottom>
                        Couple's Information Form
                    </Typography>
                    <DownloadButton url={`/approval/downloads/couple-information-form?couple_hash=${wedding.hash}`} />
                </CardContent>
                <Divider light />
                {!isApproved && (<CardActions>
                    <FormGroup>
                        <FormControlLabel
                            className={classes.approvalLabel}
                            control={
                                <Checkbox color="primary" id="approve-information-form" checked={state.approve_information_form} onChange={handleChange('approve_information_form')} />
                            }
                            label="Approve Couple's Information Form"
                        />
                    </FormGroup>
                </CardActions>)}
            </Card>
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.title} color="primary" gutterBottom>
                        Wedding Ceremony Contract
                    </Typography>
                    <DownloadButton url={`/approval/downloads/wedding-ceremony-contract?couple_hash=${wedding.hash}`} />
                </CardContent>
                <Divider light />
                {!isApproved && (<CardActions>
                    <FormGroup>
                        <FormControlLabel
                            className={classes.approvalLabel}
                            control={
                                <Checkbox color="primary" id="approve-ceremony-contract" checked={state.approve_wedding_ceremony_contact} onChange={handleChange('approve_wedding_ceremony_contact')} />
                            }
                            label="Approve Wedding Ceremony Contract"
                        />
                    </FormGroup>
                </CardActions>)}
            </Card>
            <Grid container justify="center" alignItems="center" spacing={3} style={{marginTop: 30}}>
                <Grid item xs={12}>
                    {!isApproved && (
                        <FormGroup className={classes.termsGroup}>
                            <FormControlLabel
                                control={
                                    <Checkbox color="primary" id="approve-terms" checked={state.approve_terms} onChange={handleChange('approve_terms')} />
                                }
                                label={
                                    <span>
                                        I/We have read and agree to the <a href="#" onClick={toggleTerms}>Terms and Conditions</a> and
                                        hereby electronically sign the Wedding Ceremony Contract on <b>{currentDate.day}</b> at <b>{currentDate.time}</b>.
                                    </span>
                                }
                            />
                        </FormGroup>
                    )}
                    {isApproved && (
                        <Typography variant="caption">
                            Couple agreed to the <a href="#" onClick={toggleTerms}>Terms and Conditions</a> and electronically signed
                            the Wedding Ceremony Contract on: <strong>{wedding.couple_agree_date_formatted}</strong>.
                        </Typography>
                    )}
                </Grid>
                <Grid item xs={12}>
                    {!isApproved && (
                        <Button
                            onClick={submitForm}
                            style={{width: 200}}
                            variant="contained"
                            color="primary"
                            disabled={!state.approve_information_form || !state.approve_wedding_ceremony_contact || !state.approve_terms}
                        >
                            Submit
                        </Button>
                    )}
                    {isApproved && (
                        <Button href="/couple" className={classes.homeButton} variant="contained" color="primary">Home</Button>
                    )}
                </Grid>
            </Grid>
            <TermsAndConditionsDialog open={open} setOpen={setOpen} />
        </Container>
    );
}

export default ApprovalTerms;
